﻿﻿import { IClosedLoopCreateLinkRequest } from './closed-loop-create-link-request';

export interface IClosedLoopCreateRequest {
    centerId: number;
    registrationId: number;
    donorId: number;
    donorShieldDirectId: number;
    watrRequestId: number;
    followUpDonorId: number;
    links: IClosedLoopCreateLinkRequest;
    firstName: string;
    lastName: string;
    address: string;
    city: string;
    state: string;
    postalCode: string;
    phone: string;
    email: string;
    birthDate: string;
    registrationDate: string;
    donationDate: string;
    donorType: string;
}
